// @ts-generator-hash: 924b85907210a2d5c546ddd46126162a4d0f78fe40c52c29fca16840c48fafb2
// Generation date: 9/22/2026 11:09:52 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.PhaseWorkflowType
export enum PhaseWorkflowType {
  Phase = 0,
  Step = 1,
  None = 2,
  PhaseHybrid = 3,
  StepHybrid = 4,
}
